import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Progetto} from "../../Progetti/Models/Progetto";
import {Fattura} from "../../Prima_Nota/Models/fattura";
import {number} from "ngx-custom-validators/src/app/number/validator";
import {environment} from "../../../environments/environment";
import {VoceProgetto} from "../../Progetti/Models/VoceProgetto";
import {Prodotto} from "../../Progetti/Models/Prodotto";
import {IDropdownSettings} from "ng-multiselect-dropdown";
import {ClassicType} from "../../shared/models/ClassicType";
import {Sede} from "../../Admin/models/Sede";
import {Variazione} from "../../Progetti/Models/Variazione";
import {ApiRestService} from "../../Progetti/_services/api-rest.service";
import {ProdottiStoreService} from "../../Progetti/_services/prodotti-store.service";
import {ToastrService} from "ngx-toastr";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ApiRestService as ClientiApi} from "../../Admin/_service/api-rest.service";
import {FiltriProdotto} from "../../Progetti/Models/FiltriProdotto";
import {Prezzo} from "../../Progetti/Models/Prezzo";

@Component({
  selector: 'app-voci-costo',
  templateUrl: './voci-costo.component.html',
  styleUrls: ['./voci-costo.component.css']
})
export class VociCostoComponent implements OnInit {
  @Input()
  myProp: VoceProgetto[];
  // Use in your component to write an updated value back out to the parent  // Output prop name must be Input prop name + 'Change'
  @Output()
  myPropChange = new EventEmitter<VoceProgetto[]>();
  @Input() isModifyDisabled: boolean = false;
  VoceProgettoSelezionata: VoceProgetto
  @Output() resetpage = new EventEmitter<VoceProgetto[]>();

  constructor(
              private toastService: ToastrService,
              private modalService: NgbModal,
              private clientiApi: ClientiApi
  ) { }

  ngOnInit() {
  }

  add() {
        this.myProp.push({
          voce: "",
          quantita: 1,
          prezzo: 0,
          um: "",
          modifica: true,
          prezzi: []
        })
    this.myPropChange.emit(this.myProp);
  }
  getPrezzo(data): number{
    if(data.prezzi && data.prezzi.length >0)
      return parseInt(data.prezzi[0].prezzo.toString())
    else
      return 0
  }
  getTotale(data: VoceProgetto[]){
    var out: number = 0;
    data.forEach(element=>{
      element.totale = element.prezzo * element.quantita
      out = out + element.totale;
    })
    return out;
  }
  edit(item: VoceProgetto, modale?: NgbModal) {
    this.VoceProgettoSelezionata = item;

      if(item.modifica ){
        if (item.um.length > 0 && item.voce != " " && item.voce != "" && item.voce != null){
          item.modifica = !item.modifica;
          this.myPropChange.emit(this.myProp);
        }
        else if (item.um.length > 0)
          this.toastService.warning("inserire un nome", "Attenzione!!");
        else
          this.toastService.warning("inserire un'unità di misura", "Attenzione!!");
      }else {
        item.modifica = !item.modifica;
      }

  }
  delete(item: VoceProgetto) {
    if(item.modifica && item.id)
      this.resetpage.emit(this.myProp);
    else {
      const idx: number = this.myProp.findIndex(x => x == item);
      if (idx > -1) {
        this.myProp.splice(idx, 1);
        this.myPropChange.emit(this.myProp);
      }
    }
  }
  sedeCambiata() {
    // if (this.myProp.sediObject && this.myProp.sediObject != null && this.myProp.sediObject.length > 0)
    //   this.myProp.sede_id = this.myProp.sediObject[0].id;
  }
  openModal(modale: NgbModal){
    this.modalService.open(modale, {
      centered: true,
      backdrop: 'static',
      size: 'xl'
    });
  }
  closeBtnClick() {
    this.modalService.dismissAll();
  }


}
